module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst additionalAttributes = []\nconst additionalClasses = []\nif(config.class) additionalClasses.push(config.class);\nif(model.showLinksAsButtons) additionalClasses.push('showLinksAsButtons');\nif(additionalClasses.length){\nadditionalAttributes.push(`class=\"${additionalClasses.join(' ')}\"`)\n}\n%><div <%- additionalAttributes.join(' ') %>><%\nif(model.headline) {\n%><div class=\"headline\"><%- model.headline %></div><%\n}\nif(model.content) {\n%><%- model.content %><%\n}\n%></div>"
  , __filename = "components/templates/core/text/text.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const additionalAttributes = []
const additionalClasses = []
if(config.class) additionalClasses.push(config.class);
if(model.showLinksAsButtons) additionalClasses.push('showLinksAsButtons');
if(additionalClasses.length){
additionalAttributes.push(`class="${additionalClasses.join(' ')}"`)
}

    ; __line = 9
    ; __append("<div ")
    ; __append( additionalAttributes.join(' ') )
    ; __append(">")
    ; 
if(model.headline) {

    ; __line = 11
    ; __append("<div class=\"headline\">")
    ; __append( model.headline )
    ; __append("</div>")
    ; 
}
if(model.content) {

    ; __line = 14
    ; __append( model.content )
    ; 
}

    ; __line = 16
    ; __append("</div>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/core/text/text.ejs

}